// App version from package.json
export const APP_VERSION = "0.1.0";

// Build date - automatically set during build via environment variable
// Falls back to current date in development
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || new Date().toISOString().split('T')[0];

// Format version string for display
export const getVersionString = () => `v${APP_VERSION}`;

// Format build date for display
export const getBuildDateString = () => {
    try {
        const date = new Date(BUILD_DATE);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch {
        return BUILD_DATE;
    }
};
